import { useEffect, useRef } from 'react'
import { useLocation, useSearch } from 'wouter'

import { Layout } from '@/Layout'
import { Links } from '@/templates/Links'
import { api } from '@/utils/api'

export const Home = () => {
  const [, setLocation] = useLocation()
  const search = useSearch()
  const invitationId = new URLSearchParams(search).get('invitationId')
  const isReqSent = useRef(false)

  const checkInvitation = async () => {
    if (invitationId && isReqSent.current === false) {
      isReqSent.current = true
      setLocation('/')
      await api.post(`/invitations/${invitationId}/accept`)
    }
  }

  useEffect(() => {
    checkInvitation()
  }, [])

  return (
    <Layout title="All Links">
      <Links />
    </Layout>
  )
}
